export default "__VITE_ASSET__2ncaZe$h__"